import { InterestAcrualType } from './InterestAcrualType';

export const InterestAcrualTypeOptions = [
    {
        id: InterestAcrualType.Actual360,
        name: 'Actual/360',
    },
    {
        id: InterestAcrualType.Thirty360,
        name: '30/360',
    },
    {
        id: InterestAcrualType.Actual365,
        name: 'Actual/365',
    },
];
